export default function convertCssStringPropToNumber(cssStringProp: string) {
  return parseInt(cssStringProp, 10);
}
